import { FormControl, FormGroup } from '@angular/forms';
import { PublicIssueType } from '../enums/public-issue-type';
import { Guid, Nillable } from '@web/utils';
import { PublicIssueComplaintType } from '../enums/public-issue-complaint-type';

export type PublicIssueFormControls = {
  recaptcha: FormControl<boolean>;
  type: FormControl<Nillable<PublicIssueType>>;
  dignity: FormControl<Nillable<string>>;
  email: FormControl<Nillable<string>>;
  phone: FormControl<Nillable<string>>;
  message: FormControl<Nillable<string>>;
  acceptRules: FormControl<boolean>;
  complaint: PublicIssueComplaintFormGroup;
};

export type PublicIssueComplaintFormControls = {
  reasons: FormControl<Nillable<PublicIssueComplaintType[]>>;
  orderNumber: FormControl<Nillable<string>>;
  fileIds: FormControl<Nillable<Guid[]>>;
};

export class PublicIssueForm {
  public static readonly DignityMaxLength = 255;
  public static readonly PhoneMaxLength = 30;
  public static readonly MessageMaxLength = 10000;

  public constructor(
    private readonly data: {
      type: PublicIssueType;
      dignity: string;
      email: string;
      phone: string;
      message: string;
      acceptRules: boolean;
      complaint: Nillable<PublicIssueComplaintForm>;
    },
  ) {}

  public get type(): PublicIssueType {
    return this.data.type;
  }

  public get dignity(): string {
    return this.data.dignity;
  }

  public get email(): string {
    return this.data.email;
  }

  public get phone(): string {
    return this.data.phone;
  }

  public get message(): string {
    return this.data.message;
  }
  public get acceptRules(): boolean {
    return this.data.acceptRules;
  }

  public get complaint(): Nillable<PublicIssueComplaintForm> {
    return this.data.complaint;
  }
}
export class PublicIssueComplaintForm {
  public static readonly OrderNumberMaxLength = 20;

  public constructor(
    private readonly data: {
      reasons: PublicIssueComplaintType[];
      orderNumber: string;
      fileIds: Guid[];
    },
  ) {}

  public get reasons(): PublicIssueComplaintType[] {
    return this.data.reasons;
  }

  public get orderNumber(): string {
    return this.data.orderNumber;
  }

  public get fileIds(): Guid[] {
    return this.data.fileIds;
  }
}

/* prettier-ignore */
export type PublicIssueFormGroup = FormGroup<PublicIssueFormControls>;
/* prettier-ignore */
export type PublicIssueComplaintFormGroup = FormGroup<PublicIssueComplaintFormControls>;
